import { useEffect, useMemo } from 'react';
import { useMobxForm } from '../';
import { BuilderStore, } from './';
import { getAutoGeneratedAjvSchema } from './FormBuilder.helpers';
export function useFormBuilder({ id, payload, onSubmit, ajvSchema, globalValidation, template, variables, renderType = 'form', defaultFieldMode = 'default', custom, }) {
    const form = useMobxForm(useMemo(() => ({ id, initialValues: payload, ajvSchema, validators: globalValidation }), [id, payload, ajvSchema]));
    const builder = useMemo(() => {
        return new BuilderStore({ payload, template, variables }, form, {
            renderType,
            defaultFieldMode,
            custom,
        });
    }, [form, template]);
    useEffect(() => {
        template.forEach((item) => {
            const autoGeneratedAjvSchema = getAutoGeneratedAjvSchema(item.variant, builder);
            if (autoGeneratedAjvSchema) {
                form.updateAjvSchema(autoGeneratedAjvSchema);
            }
        });
    }, [builder]);
    return {
        form,
        builder,
        onSubmit,
    };
}
